import {
  FETCH_VEHICLES_DOCUMENTS_TYPES_DATA,
  FETCH_VEHICLES_DOCUMENTS_TYPES_SUCCESS,
  FETCH_VEHICLES_DOCUMENTS_TYPES_FAILURE,
  DELETE_VEHICLES_DOCUMENTS_TYPE,
  DELETE_VEHICLES_DOCUMENTS_TYPE_SUCCESS,
  DELETE_VEHICLES_DOCUMENTS_TYPE_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  deleteLoading: false,
  deleteError: null,
};

const vehiclesDocumentsTypes = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VEHICLES_DOCUMENTS_TYPES_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_VEHICLES_DOCUMENTS_TYPES_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_VEHICLES_DOCUMENTS_TYPES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_VEHICLES_DOCUMENTS_TYPE:
      return { ...state, deleteLoading: true, deleteError: null };
    case DELETE_VEHICLES_DOCUMENTS_TYPE_SUCCESS:
      return { ...state, deleteLoading: false, deleteError: null };
    case DELETE_VEHICLES_DOCUMENTS_TYPE_FAILURE:
      return { ...state, deleteLoading: false, deleteError: action.payload };
    default:
      return state;
  }
};

export default vehiclesDocumentsTypes;
